import { map, filter, identity, size } from 'lodash/fp';

import getByMode from '../../../utils/getByMode';

import chuck from './chuck';
import mandi from './mandi';

export default async (sourceItem, targetItem) => {
  const validators = getByMode({
    chuck,
    mandi,
  });

  const executeValidator = async ({ check, errorMessage }) => {
    try {
      const valid = await check(sourceItem, targetItem);

      return (valid
        ? false
        : errorMessage(sourceItem, targetItem)
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in Vaildation:', error);
      return errorMessage(sourceItem, targetItem);
    }
  };

  const errorPromises = map(executeValidator, validators);
  const errorResults = await Promise.all(errorPromises);

  const errors = filter(identity, errorResults);

  return {
    isValid: size(errors) === 0,
    errors,
  };
};
